import { defineMessages } from 'dibs-react-intl';

export default defineMessages({
    optional: {
        defaultMessage: 'Optional',
        id: 'du.dibs-address-validator.optional',
    },
    firstName: {
        defaultMessage: 'Please enter your first name.',
        id: 'du.dibs-address-validator.firstName',
    },
    firstNameMax: {
        defaultMessage: 'This field may only contain no more than 40 letters',
        id: 'du.dibs-address-validator.firstNameLength',
    },
    lastName: {
        defaultMessage: 'Please enter your last name.',
        id: 'du.dibs-address-validator.lastName',
    },
    lastNameMax: {
        defaultMessage: 'This field may only contain no more than 80 letters',
        id: 'du.dibs-address-validator.lastNameLength',
    },
    line1: {
        defaultMessage: 'Please enter an address.',
        id: 'du.dibs-address-validator.address',
    },
    city: {
        defaultMessage: 'Please enter a city.',
        id: 'du.dibs-address-validator.city',
    },
    state: {
        defaultMessage: 'Please select a state.',
        id: 'du.dibs-address-validator.state',
    },
    phoneNumber: {
        defaultMessage: 'Please enter a valid phone number.',
        id: 'du.dibs-address-validator.phoneNumber',
    },
    zipCode: {
        defaultMessage: 'Please enter a valid zip code.',
        id: 'du.dibs-address-validator.zipCode',
    },
    label: {
        defaultMessage: 'Please enter a label',
        id: 'du.dibs-address-validator.label',
    },
    required: {
        defaultMessage: 'Required field',
        id: 'du.dibs-address-validator.required',
    },
    specialCharacters: {
        defaultMessage: 'Should not contain special characters: !@#$%^&*()+=><?',
        id: 'du.dibs-address-validator.specialCharacters',
    },
    specialCharactersShort: {
        defaultMessage: 'No special characters',
        id: 'du.dibs-address-validator.specialCharactersShort',
    },
    specialCharactersAddress: {
        defaultMessage: 'Should not contain special characters: !@$%^&*()+=><?',
        id: 'du.dibs-address-validator.specialCharactersAddress',
    },
    poBox: {
        defaultMessage: 'Item may not ship to PO Box',
        id: 'du.dibs-address-validator.poBox',
    },
    globalZipCode: {
        defaultMessage:
            'This field may only contain no more than 9 letters, numbers, spaces, and hyphens',
        id: 'du.dibs-address-validator.globalZipCode',
    },
    usZipCode: {
        defaultMessage: 'This field may only contain numbers, spaces, and hyphens',
        id: 'du.dibs-address-validator.usZipCode',
    },
    usZipCodeShort: {
        defaultMessage: 'Please enter a valid 5-digit U.S. ZIP code',
        id: 'du.dibs-address-validator.usZipCodeShort',
    },
    usZipCodeShipping: {
        defaultMessage: 'Please enter a valid U.S. ZIP code',
        id: 'du.dibs-address-validator.usZipCodeShipping',
    },
});
